import axios from "../network/reuset";
import qs from "qs";

const getAdLog = {
  getAdLogList(params) {
    return axios.post(`/api/admin/ad_log/list`, qs.stringify(params));
  },
};

export default getAdLog;
